/**
 * Login Page — admin email entry to start a session
 */
import React, { useState } from "react";
import { auth, saveSession } from "./api.js";

interface Props { onLogin: () => void; }

export function LoginPage({ onLogin }: Props) {
  const [email, setEmail]   = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError]   = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true); setError(null);
    try {
      const result = await auth.login(email.trim());
      saveSession(result.token, result.roleName);
      onLogin();
    } catch (err: any) {
      setError(err.message ?? "Login failed. Check your email is in the admin allowlist.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="ops-login-page">
      <div className="ops-login-card">
        <h1 className="ops-login-title">
          <span style={{ color: "var(--ops-accent)" }}>Bizzness OS</span> Ops
        </h1>
        <p className="ops-login-sub">Internal Operations Dashboard</p>
        {error && <div className="ops-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="ops-form-group">
            <label className="ops-form-label">Admin email</label>
            <input
              className="ops-input"
              type="email"
              placeholder="you@bizzness.in"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoFocus
              required
            />
          </div>
          <button
            type="submit"
            className="ops-btn ops-btn-primary"
            style={{ width: "100%", justifyContent: "center" }}
            disabled={loading}
          >
            {loading ? "Logging in…" : "Continue →"}
          </button>
        </form>
      </div>
    </div>
  );
}
